<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Abbreviations of Frequently Cited Works by Gershom Scholem">
<p class="fm_h" id="sec1"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii"><a href="#/text/9780253062093_Contents#rsec1">ABBREVIATIONS OF FREQUENTLY CITED WORKS BY GERSHOM SCHOLEM</a></span></p>
<p class="h1"><span class="smallcaps">GERMAN</span><sup><a id="fna-1"></a><a href="#/text/9780253062093_Abbreviations#rfna-1">1</a></sup></p>
<table class="table">
<colgroup>
<col style="width:15%"/>
<col style="width:85%"/>
</colgroup>
<tbody><tr>
<td class="td"><p class="abbr"><i>Br I</i>, <i>Br II</i>,</p></td>
<td class="td"><p class="abb"><i>Briefe</i>. Edited by Itta Shedletzky and Thomas Sparr.</p></td>
</tr>
<tr>
<td class="td"><p class="abbr"><i>Br III</i></p></td>
<td class="td"><p class="abb">3 vols. Munich: C. H. Beck, 1994–1999.</p></td>
</tr>
<tr>
<td class="td"><p class="abbr"><i>T I</i>, <i>T II</i></p></td>
<td class="td"><p class="abb"><i>Tagebücher nebst Äufsätzen und Entwürfen bis 1923</i>. Edited by Herbert Kopp-Oberstebrink, Karlfried Gründer, and Friedrich Niewöhner. 2 vols. Frankfurt: Suhrkamp, 1995–2000.</p></td>
</tr>
</tbody></table>
<p class="h1"><span class="smallcaps">ENGLISH</span></p>
<table class="table">
<colgroup>
<col style="width:15%"/>
<col style="width:85%"/>
</colgroup>
<tbody><tr>
<td class="td"><p class="abb"><i>FBJ</i></p></td>
<td class="td"><p class="abb"><i>From Berlin to Jerusalem: Memories of My Youth</i>. Translated by Harry Zohn. New York: Schocken Books, 1980.</p></td>
</tr>
<tr>
<td class="td"><p class="abb"><i>JJC</i></p></td>
<td class="td"><p class="abb"><i>On Jews and Judaism in Crisis: Selected Essays</i>. Edited by Werner J. Dannhauser. New York: Schocken Books, 1976.</p></td>
</tr>
<tr>
<td class="td"><p class="abb"><i>KS</i></p></td>
<td class="td"><p class="abb"><i>On the Kabbalah and Its Symbolism</i>. Translated by Ralph Manheim. New York: Schocken Books, 1969.</p></td>
</tr>
<tr>
<td class="td"><p class="abb"><i>LL</i></p></td>
<td class="td"><p class="abb"><i>A Life in Letters, 1914–1982</i>. Edited and translated by Anthony David Skinner. Cambridge, MA: Harvard University Press, 2002.</p></td>
</tr>
<tr>
<td class="td"><p class="abb"><span class="right_1" epub:type="pagebreak" id="page_viii" title="viii"><i>LY</i></span></p></td>
<td class="td"><p class="abb"><i>Lamentations of Youth: The Diaries of Gershom Scholem, 1913–1919</i>. Edited and translated by Anthony David Skinner. Cambridge, MA: Harvard University Press, 2007.</p></td>
</tr>
<tr>
<td class="td"><p class="abb"><i>MI</i></p></td>
<td class="td"><p class="abb"><i>The Messianic Idea in Judaism and Other Essays on Jewish Spirituality</i>. New York: Schocken Books, 1971.</p></td>
</tr>
<tr>
<td class="td"><p class="abb"><i>MS</i></p></td>
<td class="td"><p class="abb"><i>On the Mystical Shape of the Godhead: Basic Concepts in the Kabbalah</i>. Translated by Joachim Neugroschel. Edited and revised by Jonathan Chipman. New York: Schocken Books, 1991.</p></td>
</tr>
<tr>
<td class="td"><p class="abb"><i>MT</i></p></td>
<td class="td"><p class="abb"><i>Major Trends in Jewish Mysticism</i>. New York: Schocken Books, 1961.</p></td>
</tr>
<tr>
<td class="td"><p class="abb"><i>PM</i></p></td>
<td class="td"><p class="abb"><i>On the Possibility of Jewish Mysticism in Our Time and Other Essays</i>. Translated by Jonathan Chipman. Edited and selected with an introduction by Avraham Shapira. Philadelphia: The Jewish Publication Society, 1997.</p></td>
</tr>
<tr>
<td class="td"><p class="abb"><i>SS</i></p></td>
<td class="td"><p class="abb"><i>Sabbatai Sevi: The Mystical Messiah, 1626–1676</i>. Translated by R. J. Zwi Werblowsky. Princeton, NJ: Princeton University Press, 1973.</p></td>
</tr>
</tbody></table>
<p class="line"></p>
<p class="note_para"><a id="rfna-1"></a><a href="#/text/9780253062093_Abbreviations#fna-1">1</a>. Passages from Scholem’s letters and diaries that are not included in the English collections <i>A Life in Letters</i> and <i>Lamentations of Youth</i> have been translated from the German by Sage Anderson.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253062093_Abbreviations.vue?0dd3ae69